export const flyTo = (coordinates, zoomLvl) => {
  window.map.flyTo({
    center: coordinates,
    zoom: zoomLvl,
    speed: 1,
  });
};

export const mapCenterPC = [76.91537388145935, 43.21269175727281];
